import {styled} from "@mui/material";

export const Select = styled('select')({
  lineHeight: '1em',
  height: '20px',
});
